import React, { useMemo } from 'react';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import RankingSection from './RankingSection.jsx';
import './RankingWidget.css';

const RANKING_TABS = {
  rugby: [
    { key: 'tries', title: "MARQUEURS D'ESSAIS" },
    { key: 'scorers', title: 'RÉALISATEURS' },
    { key: 'stars', title: 'ÉTOILES' },
  ],
  soccer: [
    { key: 'goals', title: 'BUTEURS' },
    { key: 'assists', title: 'PASSEURS' },
    { key: 'stars', title: 'ÉTOILES' },
  ],
};

const getTabIndexFromStatType = (tabs, statType) => {
  const index = tabs.findIndex((tab) => tab.key === statType);
  return index === -1 ? 0 : index;
};

const normalizeSeasonLabel = (season) => {
  const value = String(season || '').trim();
  if (!value) return '';
  return value.split(',').map((part) => part.trim()).filter(Boolean).join(', ');
};

export default function PlayerRankingWidget({
  discipline = 'rugby',
  competitionIds = [],
  season,
  token,
  baseUrl = '',
  onNavigate,
  widgetConfigurationId = null,
  title,
  showCompetitionInfos = true,
  defaultLimit = 20,
  limitOptions = [10, 20, 50, 100],
  statType = '',
  onStatTypeChange,
  showLimitSelector = false,
}) {
  const tabs = useMemo(() => RANKING_TABS[discipline] || [], [discipline]);
  const activeTab = getTabIndexFromStatType(tabs, statType);
  const currentTab = tabs[activeTab];
  const seasonLabel = normalizeSeasonLabel(season);
  const hasHeader = showCompetitionInfos && (title || seasonLabel);

  const handleTabChange = (_, value) => {
    const nextStatType = tabs[value]?.key;
    if (!nextStatType) return;

    onStatTypeChange?.(nextStatType, {
      isDefaultTab: value === 0,
    });
  };

  return (
    <Box component="section" className="player-ranking-widget">
      <Box className="player-ranking-widget__container">
        <Box className="player-ranking-widget__stack">
          {hasHeader ? (
            <Box className="player-ranking-widget__competition-band">
              <Typography component="h2" className="player-ranking-widget__competition-title" noWrap>
                {title || 'Statistiques joueurs'}
              </Typography>

              {seasonLabel ? (
                <Typography component="p" className="player-ranking-widget__competition-season">
                  Saison {seasonLabel}
                </Typography>
              ) : null}
            </Box>
          ) : null}

          {currentTab ? (
            <>
              <Box className="player-ranking-widget__tabs-wrap">
                <Tabs
                  value={activeTab}
                  onChange={handleTabChange}
                  variant="scrollable"
                  scrollButtons="auto"
                  allowScrollButtonsMobile
                  aria-label="Types de statistiques joueurs"
                  className="player-ranking-widget__tabs"
                >
                  {tabs.map((tab) => (
                    <Tab key={tab.key} disableRipple label={tab.title} className="player-ranking-widget__tab" />
                  ))}
                </Tabs>
              </Box>

              <Box className="player-ranking-widget__panel">
                <RankingSection
                  statType={currentTab.key}
                  discipline={discipline}
                  competitionIds={competitionIds}
                  season={season}
                  widgetConfigurationId={widgetConfigurationId}
                  token={token}
                  baseUrl={baseUrl}
                  limit={defaultLimit}
                  limitOptions={limitOptions}
                  showLimitSelector={showLimitSelector}
                  sort="value_desc"
                  onNavigate={onNavigate}
                />
              </Box>
            </>
          ) : null}
        </Box>
      </Box>
    </Box>
  );
}
